<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import AppMenuItem from './AppMenuItem.vue';
import { storeToRefs } from 'pinia';
import { useSessionStore } from '@stores';
import { useAuthStore } from '@stores';

const authStore = useAuthStore();
const sessionStore = useSessionStore();
const isModerator = computed(() => authStore.user.roles == 'Moderator');
const isAdmin = computed(() => authStore.user.roles == 'Admin');
const { sessionsList } = storeToRefs(sessionStore);
const filesUrl = 'https://proctoring-api.univora.uz/services/platon-core/uploads/files/';

const mappedSessionsList = computed(() => {
    return sessionsList.value.map((session) => {
        return {
            label: session.name,
            icon: 'pi pi-fw pi-circle',
            to: `/session/${session.session_id}`,
        };
    });
});

const { t } = useI18n({ useScope: 'global' });

const model = computed(() => [
    {
        label: t('global.main'),
        items: [
            { label: t('global.review'), icon: 'pi pi-fw pi-compass', to: '/' },
            { label: t('global.sessions'), icon: 'pi pi-fw pi-address-book', to: '/sessions' },
            ...(isModerator.value
                ? []
                : [
                      { label: t('apikey.apiKeys'), icon: 'pi pi-key', to: '/apikeys' },
                      { label: t('userCreate.title'), icon: 'pi pi-user-plus', to: '/user_create' },
                  ]),
            ...(isAdmin.value ? [{ label: t('tests.constructor'), icon: 'pi pi-plus', to: '/tests' }] : []),
        ],
    },
    {
        label: t('global.sessions'),
        items: mappedSessionsList.value,
    },
]);
</script>

<template>
    <AvatarLine :src="authStore.user.image && filesUrl + authStore.user.image" :name="authStore.user.full_name" class="avatar" to="/profile" />

    <ul class="layout-menu">
        <template v-for="(item, i) in model" :key="item">
            <AppMenuItem v-if="!item.separator" :item="item" :index="i" />
            <li v-if="item.separator" class="menu-separator"></li>
        </template>
    </ul>
    <ul class="layout-menu layout-menu-logout">
        <AppMenuItem
            to="/logout"
            :item="{
                items: [{ label: t('global.exit'), icon: 'pi pi-fw pi-sign-out', to: '/logout' }],
            }"
        >
        </AppMenuItem>
    </ul>
</template>

<style scoped>
.layout-menu-logout {
    @apply flex-none;
}

.avatar {
    @apply px-8 py-4;
}
</style>
